import { api } from './apiClient';

export interface HsnCode {
  id: number;
  hsn_code: string;
  description: string;
  gst_rate: number;
  category?: string;
  is_active?: number | boolean;
}

interface HsnCodesResponse {
  hsnCodes: HsnCode[];
  count: number;
}

interface HsnCodeResponse {
  hsnCode: HsnCode;
}

export const hsnService = {
  /**
   * Get all HSN codes
   */
  getAll: async (params?: { category?: string; search?: string; limit?: number }): Promise<HsnCodesResponse> => {
    return api.get<HsnCodesResponse>('/hsn', { params });
  },

  /**
   * Search HSN codes
   */
  search: async (query: string, limit = 20): Promise<HsnCodesResponse> => {
    return api.get<HsnCodesResponse>('/hsn/search', { params: { q: query, limit } });
  },

  /**
   * Get HSN code by ID
   */
  getById: async (id: number): Promise<HsnCodeResponse> => {
    return api.get<HsnCodeResponse>(`/hsn/${id}`);
  },

  /**
   * Create new HSN code
   */
  create: async (data: { hsn_code: string; description: string; gst_rate: number; category?: string }): Promise<HsnCodeResponse> => {
    return api.post<HsnCodeResponse>('/hsn', data);
  },

  /**
   * Update an existing HSN code (migration 068/F1).
   */
  update: async (id: number, data: { hsn_code?: string; description?: string; gst_rate?: number; category?: string }): Promise<HsnCodeResponse> => {
    return api.put<HsnCodeResponse>(`/hsn/${id}`, data);
  },

  /**
   * Soft-delete (deactivate) an HSN code — safer than DELETE given products
   * reference the code string.
   */
  deactivate: async (id: number): Promise<HsnCodeResponse> => {
    return api.patch<HsnCodeResponse>(`/hsn/${id}/deactivate`);
  },
};
